<template>
<div class="chapter">
<div class="inner_page">
<p class="paraf"><span class="small">ABOUT THE AUTHOR</span></p>
<p class="para">Alastair McKay grew up in North Berwick. He has written for <em>Uncut</em> magazine, the <em>Evening Standard</em>, <em>NME</em>, <em>The Scotsman</em>, <em>Scotland on Sunday</em>, <em>The Sunday Times</em>, <em>The Guardian</em>, <em>Black Book</em>, <em>Out</em>, <em>Blah Blah Blah</em> and <em>The Independent</em>. He lives in London with his partner, his spirited daughter and a lazy cat.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?58c7d6f4